// extracted by mini-css-extract-plugin
module.exports = {"container":"legal-module--container--2TJmF"};